import { observable } from 'mobx';
import RootStore from './RootStore';
import BaseLoginStore from './BaseLoginStore';

export interface PersonalCodeLoginCredentials {
  personalCode: string;
  username: string;
  password: string;
}

export default class PersonalCodeLoginStore extends BaseLoginStore {
  @observable accessor personalCodeLoginCredentials: PersonalCodeLoginCredentials = {
    personalCode: '',
    username: '',
    password: '',
  };

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public async handleLogin() {
    await this.handleLoginTemplate('/personal/code/auth', this.personalCodeLoginCredentials);
  }
}
